import React from "react";

import { Box } from "@mui/material";

const MONO_FONT_SX = {
  fontFamily: `ui-monospace, "SF Mono", Menlo, Consolas, monospace`,
  fontSize: "0.75rem",
};

export function MonoText({ children }: { children: React.ReactNode }) {
  return (
    <Box component="span" sx={MONO_FONT_SX}>
      {children}
    </Box>
  );
}
